import React, {FC, PropsWithChildren} from 'react';
import {observer} from 'mobx-react-lite';
import {Container, I18NText, Icon, useIcons} from '@yosmanyga/rich-ui';

export const NotesHelp = observer(
    ({
        templates,
    }: {
        templates: {
            layout: FC<PropsWithChildren>;
        };
    }) => {
        const icons = useIcons();

        return (
            <templates.layout>
                <Container
                    flow="row wrap"
                    align={{
                        cross: 'center',
                    }}
                >
                    <I18NText>Notes Help Line 1</I18NText>
                </Container>

                <Container
                    flow="row wrap"
                    align={{
                        cross: 'center',
                    }}
                    margin={{
                        top: 1,
                    }}
                >
                    <I18NText>Notes Help Line 2</I18NText>
                </Container>

                <Container
                    flow="row wrap"
                    align={{
                        cross: 'center',
                    }}
                    margin={{
                        top: 1,
                    }}
                >
                    <I18NText
                        values={{
                            icon: (
                                <Icon
                                    component={icons.actions.remove}
                                    align={{
                                        vertical: 'middle',
                                    }}
                                    margin={{
                                        left: 0.5,
                                        right: 0.5,
                                    }}
                                />
                            ),
                        }}
                    >
                        Notes Help Line 3
                    </I18NText>
                </Container>
            </templates.layout>
        );
    }
);
